import { gql } from '@apollo/client'

export default gql(`
query getArticlePreview($id:ID!){
    getArticlePreview(
        id:  $id
    ){
        previewUrl
        identifier
        isPreview
        revision
        selfUrl
        id
    }
}`)
